// extracted by mini-css-extract-plugin
export default {"month":"ckXo6m","sr-only":"kCIYnh","srOnly":"kCIYnh","text":"XQYxZO","disabled":"RsxhFD","loadingMode":"zmAmpx","today":"x1Bap2","selected":"sFNaMA"};